import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MagnifyingGlass, X } from "@phosphor-icons/react";
import api from "@/lib/api";
import { useShop } from "@/context/ShopContext";

export default function SearchDialog({ open, setOpen }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const { format } = useShop();

  useEffect(() => {
    if (!q || q.length < 2) { setResults([]); return; }
    const t = setTimeout(() => {
      api.get("/products", { params: { q, limit: 8 } }).then(r => setResults(r.data || []));
    }, 200);
    return () => clearTimeout(t);
  }, [q]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/30 backdrop-blur-sm pt-20 px-4" onClick={()=>setOpen(false)} data-testid="search-dialog">
      <div className="max-w-2xl mx-auto bg-white rounded-2xl overflow-hidden" onClick={e=>e.stopPropagation()}>
        <div className="flex items-center gap-3 p-4 border-b border-[var(--bm-border)]">
          <MagnifyingGlass size={20} weight="thin"/>
          <input autoFocus value={q} onChange={e=>setQ(e.target.value)} placeholder="Search bags, wallets…" className="flex-1 outline-none text-sm" data-testid="search-input"/>
          <button onClick={()=>setOpen(false)}><X size={18} weight="thin"/></button>
        </div>
        <div className="max-h-96 overflow-y-auto">
          {results.map(p => (
            <Link to={`/product/${p.slug}`} onClick={()=>setOpen(false)} key={p.id} className="flex gap-3 p-3 hover:bg-[#f9f9f9]" data-testid={`search-result-${p.slug}`}>
              <img src={p.images?.[0]} alt="" className="w-14 h-16 object-cover rounded-lg"/>
              <div>
                <div className="font-serif-bm text-base">{p.name}</div>
                <div className="text-xs text-[var(--bm-muted)]">{format(p.price)}</div>
              </div>
            </Link>
          ))}
          {q && !results.length && <div className="p-6 text-center text-sm text-[var(--bm-muted)]">No results for &quot;{q}&quot;</div>}
        </div>
      </div>
    </div>
  );
}
